import { RouteObject } from "react-router-dom";
import PrivateRoute from "../../Authentication/component/PrivateRoute";
import generalMasterRouteList from "./routeList";
import { lazy } from "react";
import Loader from "../../utilis/component/SkeletonLoading/Loader";
const SpecialityMaster = lazy(()=>import("./SpecialityMaster"));
const AddOrEditSpecialityMaster = lazy(()=>import("./SpecialityMaster/AddOrEditSpecialityMaster"));
const DrugMaster = lazy(()=>import("./DrugMaster"));
const AddOrEditDrug = lazy(()=>import("./DrugMaster/AddOrEditDrug"));
const CompanyMaster = lazy(() => import("./Company"));
const AddOrEditCompany = lazy(() => import("./Company/AddOrEditCompany"));
const StateMaster = lazy(() => import("./StateMaster"));
const AddOrEditState = lazy(() => import("./StateMaster/AddOrEditCountry"));
const DoctorsMaster = lazy(() => import("./Doctors"));
const DoctorAddOrEdit = lazy(() => import("./Doctors/AddOrEdit"));
const TimeSlotes = lazy(() => import("./Doctors/TimeSlotes"));
const DoctorLicense = lazy(() => import("./Doctors/DoctorLicense"));
const AddOrEditAppointmentType = lazy(
  () => import("./AppointmentType/AddOrEditAppointmentType")
);
const AppointmentTypeMaster = lazy(() => import("./AppointmentType"));
const EmployeeMaster = lazy(() => import("./Employee"));
const AddOrEditEmployee = lazy(() => import("./Employee/AddOrEditEmployee"));
const UOMMaster = lazy(() => import("./UOM"));
const UOMAddOrEdit = lazy(() => import("./UOM/UOMAddOrEdit"));
const CountryMaster = lazy(() => import("./Country"));
const AddOrEditCountry = lazy(() => import("./Country/AddOrEditCountry"));
const PurposeMaster = lazy(()=>import("./PurposeMaster"));
const AddOrEditPurpose = lazy(()=>import("./PurposeMaster/AddOrEditPurpose"));
const AccountTagMaster = lazy(()=>import("./AccountTag"));
const AddOrEditAccountTag = lazy(()=>import("./AccountTag/AddOrEditAccountTag"))
const AccountCategoryMaster = lazy(()=>import("./AccountCategory"));
const AddOrEditAccountCategory = lazy(()=>import("./AccountCategory/AddOrEditAccountCategory"));
const ClinicianMaster= lazy(() => import("./clinician"));
const AddorEditClinician=lazy(()=>import("./clinician/AddOrEditInsurance"))
export const generalMasterRoute: RouteObject[] = [
  {
    path: generalMasterRouteList.doctorMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <DoctorsMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <DoctorAddOrEdit />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.doctorLicense,
        element: (
          <PrivateRoute>
            <Loader>
              <DoctorLicense />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.doctorTimeSlot,
        element: (
          <PrivateRoute>
            <Loader>
              <TimeSlotes />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.appointmentTypeMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <AppointmentTypeMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditAppointmentType />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.employeeMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <EmployeeMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditEmployee />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.uomMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <UOMMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <UOMAddOrEdit />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.countryMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <CountryMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditCountry />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.stateMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <StateMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditState />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.purposeMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <PurposeMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditPurpose />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.accountTag,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <AccountTagMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditAccountTag />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: generalMasterRouteList.accountCategory,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <AccountCategoryMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditAccountCategory />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path:generalMasterRouteList.clinician,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <ClinicianMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddorEditClinician/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ]
  },
  {
    path:generalMasterRouteList.companyMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <CompanyMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditCompany/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ]
  },
  {
    path:generalMasterRouteList.drugMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <DrugMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditDrug/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ]
  },
  {
    path:generalMasterRouteList.specialityMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <SpecialityMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: generalMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditSpecialityMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ]
  },
];

export default generalMasterRoute;
